"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCampaigns = getCampaigns;
exports.getSfdcSettings = getSfdcSettings;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var API_BASE = 'sfdc/v1/';

var portalId = _hubspot.default.get();

function getCampaigns() {
  return _apiClient.default.get(API_BASE + "campaigns/" + portalId, {
    query: {
      detailView: false
    }
  });
}

function getSfdcSettings() {
  return _apiClient.default.get(API_BASE + "settings/");
}